import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Table, Loader, Button} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import {columnsTechnicians} from '../../constants';
import TechniciansTable from '../common/TechniciansTable';
import './styles.scss';

class Technicians extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'addTechnician': false,
    };
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.Technicians,
        scopes.See
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.fetchAllTechnicians();
    this.props.fetchUsersList();
    this.props.fetchTechniciansGroups();
  }

  componentWillUnmount() {
    this.props.clearTechnicians();
  }

  addNewTechnician = () => {
    this.setState({'addTechnician': true});
  };

  cancelAddTechnician= () => {
    this.setState({'addTechnician': false});
  };

  renderLoaderOrTechnicians = () => {
    const {loading, list, usersList, technicalGroupList} = this.props;
    const {addTechnician} = this.state;

    if (loading) {
      return (
        <Table striped className="toyota-grid">
          <Table.Body>
            <Table.Row>
              <Table.Cell colSpan="100%">
                <Loader active inline="centered" content="Ejecutando" />
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      );
    }

    return (
      <TechniciansTable
        type="technician"
        cancelAddInfo={this.cancelAddTechnician}
        addInfo={addTechnician}
        list={list}
        columnsInfo={columnsTechnicians}
        optionsList={usersList}
        technicalGroupList={technicalGroupList}
      />
    );
  };

  render() {
    return (
      <div className="logistic-tecncians-container">
        <Card raised fluid>
          <div className="title-bar">
            <div className="title">
              <h2>Mantenimiento de Técnicos</h2>
              <div className="title-bar-actions">
                <Button
                  primary
                  className="toyota-primary"
                  onClick={this.addNewTechnician}
                >
                  Añadir nuevo técnico
                </Button>
              </div>
            </div>
          </div>
        </Card>
        <Card raised fluid className="logistic-area-table">
          {this.renderLoaderOrTechnicians()}
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
    'list': state.technicians.list,
    'loading': state.technicians.loading,
    'dealerId': state.session.dealerId,
    'usersList': state.usersList.list,
    'technicalGroupList': state.technicianGroups.list,
    'isUserFromTDE': state.session.isUserFromTDE,
  };
};

const {
  fetchTechniciansGroups,
  fetchAllTechnicians,
  clearTechnicians,
  fetchUsersList,
  navigateTo,
} = Actions;

const mapDispatchToProps = {
  fetchTechniciansGroups,
  fetchAllTechnicians,
  clearTechnicians,
  fetchUsersList,
  navigateTo,
};

export default connect(mapStateToProps, mapDispatchToProps)(Technicians);
